var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 841,
    viewBox: "0 0 215 841",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.636 -386.187C59.1049 -338.287 30.9354 -141.259 53.0038 -43.4636C80.5893 78.7808 232.266 145.629 207.342 228.651C185.467 301.515 72.6714 225.399 16.775 295.253C-65.9753 398.666 222.158 537.605 235.659 706.41C243.505 804.514 189.63 848.37 101.706 837.624",
    stroke: "#9356F8",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.882 162.46L188.16 164.234L191.317 159.264L197.033 157.842L195.754 156.067L191.814 156.21L188.818 152.053L197.767 149.508L196.557 147.827L185.421 147.337L182.863 143.788C182.698 143.549 182.486 143.346 182.241 143.19C181.996 143.034 181.723 142.929 181.436 142.88C181.15 142.831 180.857 142.839 180.574 142.904C180.291 142.97 180.024 143.091 179.788 143.261C179.553 143.431 179.353 143.646 179.202 143.893C179.05 144.141 178.949 144.416 178.905 144.703C178.861 144.99 178.875 145.283 178.945 145.565C179.015 145.847 179.141 146.112 179.315 146.345L181.939 149.987L178.878 160.705L180.023 162.293L185.325 154.685L188.266 158.767L186.882 162.46Z",
    fill: "#9356F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneMobile);
export default __webpack_public_path__ + "static/media/planeMobile.0752433398c9d5aa9e49857b97e15df6.svg";
export { ForwardRef as ReactComponent };